import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ETH.svg'
import _imports_1 from '../assets/telegram.svg'
import _imports_2 from '../assets/twitter.svg'
import _imports_3 from '../assets/gm.svg'
import _imports_4 from '../assets/hamburger-menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-56a19e6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo-eth",
  src: _imports_0,
  alt: "tickets"
}, null, -1))
const _hoisted_4 = { class: "header__local-links" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"header__social-links\" data-v-56a19e6f><a href=\"https://t.me/ethprague\" target=\"_blank\" data-v-56a19e6f><img src=\"" + _imports_1 + "\" alt=\"telegram\" data-v-56a19e6f></a><a href=\"https://twitter.com/EthPrague\" target=\"_blank\" data-v-56a19e6f><img src=\"" + _imports_2 + "\" alt=\"twitter\" data-v-56a19e6f></a><a href=\"https://gm.events/\" target=\"_blank\" data-v-56a19e6f><img src=\"" + _imports_3 + "\" alt=\"gm.events\" data-v-56a19e6f></a></div>", 1)
const _hoisted_6 = { class: "header-mobile" }
const _hoisted_7 = { class: "header-mobile__content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo-eth",
  src: _imports_0,
  alt: "tickets"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"header__social-links\" data-v-56a19e6f><a href=\"https://t.me/ethprague\" target=\"_blank\" data-v-56a19e6f><img src=\"" + _imports_1 + "\" alt=\"telegram\" data-v-56a19e6f></a><a href=\"https://twitter.com/EthPrague\" target=\"_blank\" data-v-56a19e6f><img src=\"" + _imports_2 + "\" alt=\"twitter\" data-v-56a19e6f></a><a href=\"https://gm.events/\" target=\"_blank\" data-v-56a19e6f><img src=\"" + _imports_3 + "\" alt=\"gm.events\" data-v-56a19e6f></a></div>", 1)
const _hoisted_10 = { class: "header-mobile__local-links" }

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const isHamMenuOpen = ref(false);
const localLinks = [
  "Manifesto",
  // "Hackathon",
  "Speakers",
  "FAQ",
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "header__local-link",
          to: { path: '/', hash: '#manifesto-buttons' }
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localLinks, (localLink) => {
            return _createVNode(_component_router_link, {
              class: "header__local-link",
              to: { path: '/', hash: `#${localLink}` },
              key: localLink
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(localLink), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64)),
          _createVNode(_component_router_link, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isHamMenuOpen.value = false)),
            class: "header__local-link",
            to: { path: '/', hash: '#SponsorsAndPartners' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sponsors & Partners ")
            ]),
            _: 1
          })
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "header__eth-logo-link",
          to: { path: '/', hash: '#manifesto-buttons' },
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isHamMenuOpen.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createElementVNode("img", {
          class: "header-mobile__hamburger-menu",
          src: _imports_4,
          alt: "menu",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isHamMenuOpen.value = !isHamMenuOpen.value))
        }),
        _hoisted_9
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localLinks, (localLink) => {
              return _createVNode(_component_router_link, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (isHamMenuOpen.value = false)),
                class: "header-mobile__local-link",
                to: { path: '/', hash: `#${localLink}` },
                key: localLink
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(localLink), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            }), 64)),
            _createVNode(_component_router_link, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (isHamMenuOpen.value = false)),
              class: "header-mobile__local-link",
              to: { path: '/', hash: '#SponsorsAndPartners' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sponsors & Partners ")
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, isHamMenuOpen.value]
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})